// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  --background: #576d7c;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
  height: 43px;
  border-radius: 8px !important;
  --border-radius: 8px !important;
  min-width: 80% !important;
  text-transform: none;
}

ion-text {
  font-size: 20px;
  color: #ffffff;
  font-weight: normal;
}

@media screen and (max-width: 355px) {
  ion-text {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/button/button.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,2CAAA;EACA,YAAA;EACA,6BAAA;EACA,+BAAA;EACA,yBAAA;EACA,oBAAA;AACF;;AACA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAEF;;AACA;EACE;IACE,eAAA;EAEF;AACF","sourcesContent":["ion-button {\r\n  --background: #576d7c;\r\n  box-shadow: 0px 0px 15px #00000033;\r\n  height: 43px;\r\n  border-radius: 8px !important;\r\n  --border-radius: 8px !important;\r\n  min-width: 80% !important;\r\n  text-transform: none;\r\n}\r\nion-text {\r\n  font-size: 20px;\r\n  color: #ffffff;\r\n  font-weight: normal;\r\n}\r\n\r\n@media screen and (max-width: 355px) {\r\n  ion-text {\r\n    font-size: 18px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
